export const SITE_NAMES = { 1: 'Ruby Hill', 2: 'McCoy Cove', 3: 'Lone Tree', 4: 'Granite Creek' };

export function getSiteName(siteId) {
    return SITE_NAMES[siteId];
}

// Maps a workflow_state ({ step, site_id }) from GET /api/me to the route a
// returning user should be sent to resume that in-progress task.
export function workflowStatePath(workflowState) {
    if (!workflowState?.step) return null;

    switch (workflowState.step) {
        case 'acknowledge': {
            const siteName = getSiteName(workflowState.site_id);
            return siteName ? `/acknowledge/${encodeURIComponent(siteName)}` : null;
        }
        case 'approve': {
            const siteName = getSiteName(workflowState.site_id);
            return siteName ? `/approve/${encodeURIComponent(siteName)}` : null;
        }
        case 'guardian-confirm':
            return '/guardian-confirm';
        case 'visitor-confirm':
            return '/visitor-confirm';
        case 'register-visitor':
            return '/register-visitor';
        default:
            return null;
    }
}
